import { render } from "./CreateAssessmentOption.vue?vue&type=template&id=0fcb9d4d&scoped=true"
import script from "./CreateAssessmentOption.vue?vue&type=script&lang=js"
export * from "./CreateAssessmentOption.vue?vue&type=script&lang=js"

import "./CreateAssessmentOption.vue?vue&type=style&index=0&id=0fcb9d4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcb9d4d"]])

export default __exports__